import { render, staticRenderFns } from "./ModalPriceAdjust.vue?vue&type=template&id=24a2a357"
import script from "./ModalPriceAdjust.vue?vue&type=script&lang=js"
export * from "./ModalPriceAdjust.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports